import Vue from 'vue';
import { State } from '@/stores/reports/state';
import { MutationTree } from 'vuex';
import { Operator } from '@/models/reports/report-operators';
import { ReportDetails } from '@/models/reports/report-details';
import { SelectItem } from '@/models/reports/select-item';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setAllReports = (state: State, reports: Array<ReportDetails>) => {
        state.allReports = reports;
    }
    public setAllReportsPage = (state: State, page: number) => {
        state.allReportsPageNumber = page;
    }
    public setAllReportsCurrentPageSize = (state: State, pageSize: number) => {
        state.allReportsPageSize = pageSize;
    }
    public setAllReportsTotalPages = (state: State, pageCount: number) => {
        state.allReportsTotalPages = pageCount;
    }
    public setAllReportsTotal = (state: State, totalRecords: number) => {
        state.allReportsTotal = totalRecords;
    }
    public setAllReportsFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.allReportsFilterStatus = filterStatus;
    }
    public setAllReportsFrom = (state: State, from: string | null) => {
        state.allReportsFrom = from;
    }
    public setAllReportsTo = (state: State, to: string | null) => {
        state.allReportsTo = to;
    }
    public setAllReportOperators = (state: State, operators: Array<Operator>) => {
        state.allReportOperators = operators;
    }
    public setAllReportBooleanValues = (state: State, booleanValues: Array<SelectItem>) => {
        state.allReportBooleanValues = booleanValues;
    }
    public setAllReportLogicalOperators = (state: State, logicalOperators: Array<SelectItem>) => {
        state.allReportLogicalOperators = logicalOperators;
    }
}
